/**
 * @file hooks
 * @author alfielv
 */
import useForceUpdate from './useForceUpdate';
import useOriginReference from './useOriginReference';
import useCustomColumn from './useCustomColumn';
import useArray from './useArray';
import useDialog from './useDialog';
import useFetch from './useFetch';
import useAction from './useAction';
export default {
  useForceUpdate: useForceUpdate,
  useOriginReference: useOriginReference,
  useCustomColumn: useCustomColumn,
  useArray: useArray,
  useDialog: useDialog,
  useFetch: useFetch,
  useAction: useAction
};